import { render, staticRenderFns } from "./errors.vue?vue&type=template&id=ddf80d60&scoped=true&"
import script from "./errors.vue?vue&type=script&lang=js&"
export * from "./errors.vue?vue&type=script&lang=js&"
import style0 from "./errors.vue?vue&type=style&index=0&id=ddf80d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf80d60",
  null
  
)

export default component.exports